import moment from 'moment';
import api from "@/api";

export default {
  computed: {
    $ordersUnderManagerProgress() {
      return this.$store.getters["orders/newUnderManagerProgress"];
    },
  },
  methods: {
    async updateOrderUnderManagerProgress(id) {
      const records = {...this.$ordersUnderManagerProgress};
      if (records[id]?.[this.$currentUID]) return {success: true};
      if (Object.keys(records[id] ?? {}).length) return {success: false, message: 'Заявка уже в работе'};
      records[id] = {
        [this.$currentUID]: {
          actionTimeMoment: moment(),
          time: moment().format('YYYY-MM-DD HH:mm:ss')
        }
      };
      const {data} = await api.post('new/dynamic/data/set', {
        type: 'newOrderProgress',
        order_id: id,
        record: records
      })
      return {success: data.success, message: 'dynamic data not updated'};
    },
    isOrderUnderManagerProgress(id, returnUserId = false) {
      let inProgress = Object.keys(this.$ordersUnderManagerProgress[id] ?? {});
      return returnUserId ? inProgress?.[0] : inProgress.length
    },
  }
}
